import * as React from "react";
import * as ReactDOM from "react-dom";
import * as ReactRouterDom from "react-router-dom";

import packageJson from "../../package.json";

type SharedPackageName = "react" | "react-dom" | "react-router-dom";
type SharedPackageConfig = {
  lib: unknown;
  version: string;
};

const SHARED_PACKAGES_CONFIG: Record<SharedPackageName, SharedPackageConfig> = {
  react: {
    lib: React,
    version: '18.3.1',
  },
  "react-dom": {
    lib: ReactDOM,
    version: '18.3.1',
  },
  "react-router-dom": {
    lib: ReactRouterDom,
    version: '6.30.0',
  },
};

export const getSharedPackages = () => {
  const packages = packageJson.dependencies;

  return {
    shared: Object.entries(SHARED_PACKAGES_CONFIG).reduce((acc, [packageName, config]) => ({
      ...acc,
      [packageName]: {
        version: config.version,
        scope: "default",
        lib: () => config.lib,
        shareConfig: {
          singleton: true,
          requiredVersion: packages[packageName as SharedPackageName],
        },
      },
    }), {} as Record<SharedPackageName, any>),
  };
};
